<template>
  <component v-if="componentName" :is="componentName" />
</template>

<script>
export default {
  name: 'CustomLogo',
  props: {
    tenant: String,
  },
  data: () => ({
    componentName: null,
  }),
  watch: {
    tenant: {
      immediate: true,
      async handler(tenant) {
        try {
          // eslint-disable-next-line prefer-template
          const component = await import('@/themes/' + tenant + '/components/Logo/Logo.vue');

          const name = `${tenant}-logo`;
          this.$options.components[name] = component.default;
          this.componentName = name;
        } catch (e) {
          this.componentName = null;
        }
      },
    },
  },
};
</script>
